import React from 'react';

import MetaTags from '../shared/MetaTags';
import ProFooterCallout from './ProFooterCallout';
import ProHero from './ProHero';
import ProMarketingCTAs from './ProMarketingCTAs';
import ProOpportunities from './ProOpportunities';

const OG_IMAGE_PATH = '/global/og_images/pro_social_cover.gif';
const DESCRIPTION =
  'The Information Pro subscription provides tech professionals and VCs access to proprietary databases, surveys, org charts, & data they need to stay ahead.';

const Pro = () => {
  return (
    <>
      <MetaTags
        title="The Information Pro: Exclusive Data for Tech & VC Professionals"
        description={DESCRIPTION}
        ogImagePath={OG_IMAGE_PATH}
        ogSiteName="The Information"
      />
      <div className="tw-overflow-hidden" id="pro-landing-page">
        <ProHero />
        <ProMarketingCTAs />
        <ProOpportunities />
        <ProFooterCallout />
      </div>
    </>
  );
};

export default Pro;
